// extracted by mini-css-extract-plugin
module.exports = {"collapsibleArrow":"collapsibleArrow_IaTFwZj350","collapsible":"collapsible_2SRzh-Ttys","searchLabel":"searchLabel_2D14xrkAXp"};